export const characters = [
  {
    id: "chen-laogen",
    name: "陈老根",
    role: "公公",
    category: "家庭成员",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20of%20a%20kindly%20elderly%20Chinese%20grandfather%20wearing%20a%20traditional%20dark%20red%20jacket%2C%20sitting%20in%20a%20cozy%20family%20living%20room%2C%20soft%20natural%20window%20lighting%2C%20gentle%20wrinkled%20smile%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20muted%20warm%20amber%20tones%2C%20harmonious%20composition&width=500&height=500&seq=char-laogen-01&orientation=squarish",
    identity: "退休铁路工人，陈家的一家之主，老伴去世后独自守着一间老房子。",
    personality: "表面固执守旧、嘴上不饶人，内心却极为柔软，最看重的是一家人整整齐齐地坐在一起吃饭。",
    intro: "陈老根是整部剧的情感支点。他的固执来自半生的操劳，他的温柔藏在每一顿早饭里。",
    quote: "家里人哪有过不去的坎，坐下来把饭吃了就都好了。",
    tags: ["固执", "温情", "顾家", "传统"],
    episodeIds: ["1", "2", "3", "5", "8", "12", "16", "20"],
  },
  {
    id: "lin-xiaomei",
    name: "林晓梅",
    role: "儿媳",
    category: "家庭成员",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20of%20a%20graceful%20Chinese%20woman%20in%20her%20mid%20thirties%20wearing%20a%20soft%20knit%20beige%20sweater%2C%20standing%20in%20a%20bright%20modern%20apartment%20kitchen%2C%20calm%20confident%20expression%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20muted%20warm%20neutral%20tones%2C%20harmonious%20composition&width=500&height=500&seq=char-xiaomei-01&orientation=squarish",
    identity: "来自南方城市的护士，性格独立，婚后随丈夫搬进陈家老宅，是家里最年轻的成年人。",
    personality: "细心体贴又坚持原则，习惯用行动化解矛盾，从不抱怨却常常独自咽下委屈。",
    intro: "林晓梅代表了新一代儿媳的处境——既要融入传统家庭，也想守住自己的生活节奏。",
    quote: "我不是不想争，我是想让这个家更好。",
    tags: ["独立", "细心", "坚韧", "体贴"],
    episodeIds: ["1", "2", "4", "6", "9", "13", "17", "20"],
  },
  {
    id: "chen-jianguo",
    name: "陈建国",
    role: "儿子",
    category: "家庭成员",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20of%20a%20steady%20Chinese%20man%20in%20his%20late%20thirties%20wearing%20a%20simple%20grey%20shirt%2C%20standing%20beside%20a%20family%20dining%20table%2C%20thoughtful%20expression%2C%20soft%20afternoon%20lighting%2C%20editorial%20photography%2C%20muted%20warm%20tones%2C%20harmonious%20balanced%20composition&width=500&height=500&seq=char-jianguo-01&orientation=squarish",
    identity: "常年在父亲与妻子之间调和的中间人，一家小装修公司的项目经理。",
    personality: "老实踏实、不善言辞，遇到冲突就想息事宁人，是剧中最典型的“夹心层”。",
    intro: "陈建国身上有无数普通中年男人的影子，他的成长就是学会真正地倾听。",
    quote: "爸，晓梅她不是那个意思。",
    tags: ["老实", "中庸", "孝顺", "成长"],
    episodeIds: ["1", "3", "5", "7", "11", "15", "19", "20"],
  },
  {
    id: "wang-guifen",
    name: "王桂芬",
    role: "婆婆",
    category: "家庭成员",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20of%20a%20practical%20Chinese%20grandmother%20in%20her%20sixties%20wearing%20a%20floral%20light%20blouse%2C%20standing%20in%20a%20traditional%20courtyard%20home%2C%20attentive%20expressive%20face%2C%20soft%20morning%20lighting%2C%20editorial%20photography%2C%20muted%20warm%20earthy%20tones%2C%20harmonious%20composition&width=500&height=500&seq=char-guifen-01&orientation=squarish",
    identity: "陈老根的妹妹，长期帮着打理家务，是全家的“后勤部长”。",
    personality: "热心麻利、爱操心事，嘴上喜欢念叨，实则比谁都在意一家人是否和睦。",
    intro: "王桂芬让观众看到传统家庭里那种不图回报的付出与絮絮叨叨的爱。",
    quote: "我念叨还不是为你们好。",
    tags: ["热心", "唠叨", "顾家", "勤快"],
    episodeIds: ["2", "4", "6", "10", "14", "18"],
  },
  {
    id: "chen-xiaoli",
    name: "陈晓丽",
    role: "小姑",
    category: "亲戚",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20of%20a%20lively%20young%20Chinese%20woman%20in%20her%20late%20twenties%20wearing%20a%20colorful%20cardigan%2C%20standing%20in%20a%20bright%20sunlit%20living%20room%2C%20playful%20bright%20smile%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20muted%20warm%20tones%2C%20harmonious%20composition&width=500&height=500&seq=char-xiaoli-01&orientation=squarish",
    identity: "陈家的女儿，刚参加工作不久，性格直爽，是家里最敢说话的人。",
    personality: "心直口快、偶尔添乱，却总是在关键时候站在嫂子林晓梅这边。",
    intro: "陈晓丽是剧中的“气氛调节剂”，也是新老观念碰撞最鲜活的一面镜子。",
    quote: "哥，你得站嫂子这边！",
    tags: ["直爽", "机灵", "仗义", "活泼"],
    episodeIds: ["3", "5", "9", "13", "17"],
  },
  {
    id: "lin-mu",
    name: "林母",
    role: "亲家母",
    category: "亲戚",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20of%20an%20elegant%20Chinese%20mother%20in%20her%20late%20fifties%20wearing%20a%20tidy%20navy%20blazer%2C%20standing%20in%20a%20modern%20city%20apartment%2C%20dignified%20caring%20expression%2C%20soft%20indoor%20lighting%2C%20editorial%20photography%2C%20muted%20cool%20warm%20tones%2C%20harmonious%20composition&width=500&height=500&seq=char-linmu-01&orientation=squarish",
    identity: "林晓梅的母亲，退休中学教师，从南方城市赶来探望女儿。",
    personality: "知书达理又护女心切，讲究分寸，却也会为女儿的生活习惯据理力争。",
    intro: "林母的出现把一个家庭的故事拉宽成了两代人、两地观念的对话。",
    quote: "女儿嫁过去，不代表要把自己弄丢了。",
    tags: ["知性", "护短", "明理", "讲究"],
    episodeIds: ["4", "8", "12", "16", "20"],
  },
  {
    id: "chen-xiaoyu",
    name: "陈小宇",
    role: "孙子",
    category: "家庭成员",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20of%20a%20cheerful%20Chinese%20schoolboy%20around%20ten%20years%20old%20wearing%20a%20blue%20school%20uniform%20with%20a%20backpack%2C%20standing%20in%20a%20family%20courtyard%2C%20bright%20happy%20smile%2C%20soft%20daylight%2C%20editorial%20photography%2C%20muted%20warm%20tones%2C%20harmonious%20composition&width=500&height=500&seq=char-xiaoyu-01&orientation=squarish",
    identity: "陈建国与林晓梅的儿子，小学四年级，家里的“粘合剂”。",
    personality: "天真聪慧、观察力强，常常用一句童言无忌化解大人们的剑拔弩张。",
    intro: "陈小宇是全家最无辜也最敏锐的人，他的眼睛记录着这个家所有的柔软时刻。",
    quote: "爷爷，妈妈其实偷偷给你买了你爱吃的点心。",
    tags: ["天真", "聪慧", "暖心", "机灵"],
    episodeIds: ["2", "6", "10", "14", "18", "20"],
  },
  {
    id: "zhao-dashen",
    name: "赵大婶",
    role: "邻居",
    category: "邻里",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20of%20a%20chatty%20Chinese%20neighborhood%20aunt%20in%20her%20fifties%20wearing%20a%20patterned%20apron%20over%20a%20plain%20shirt%2C%20standing%20in%20a%20sunny%20old%20alley%2C%20knowing%20amused%20grin%2C%20soft%20daylight%2C%20editorial%20photography%2C%20muted%20warm%20tones%2C%20harmonious%20composition&width=500&height=500&seq=char-zhaoda-01&orientation=squarish",
    identity: "陈家多年的老街坊，社区里消息最灵通的人。",
    personality: "爱打听又热心肠，是邻里矛盾的导火索，也常常是化解误会的那把钥匙。",
    intro: "赵大婶让这部剧多了几分市井烟火气，也照出了小院里的人情冷暖。",
    quote: "我跟你说啊，这事可不能这么算。",
    tags: ["热心", "八卦", "市井", "爽快"],
    episodeIds: ["7", "11", "15", "19"],
  },
];